window.jQuery = window.$ = require('jquery');

// Arm the global CSRF auto-retry AJAX prefilter before any request can fire, so an
// expired/invalid token transparently re-submits instead of dumping the shopper on the
// CSRF-Fail page. See components/csrfRetry.js.
require('friartux/components/csrfRetry')();

var processInclude = require('base/util');
var polyfills = require('friartux/polyfills/polyfills');

polyfills.init();
require('jquery-ui-dist/jquery-ui.js');

$(document).ready(function () {
	processInclude(require('friartux/components/menu'));
	processInclude(require('base/components/cookie'));
	processInclude(require('friartux/components/consentTracking'));
	processInclude(require('friartux/components/header'));
	processInclude(require('friartux/components/footer'));
	processInclude(require('base/components/collapsibleItem'));
	processInclude(require('friartux/components/search'));
	processInclude(require('base/components/countrySelector'));
	processInclude(require('base/components/toolTip'));
	processInclude(require('friartux/components/field'));
	processInclude(require('friartux/components/miniCart'));
	processInclude(require('friartux/components/select2'));
	processInclude(require('friartux/components/clientSideValidation'));
	processInclude(require('friartux/components/scrollTopButton'));
	processInclude(require('friartux/components/mobileMenu'));
	processInclude(require('friartux/components/promoCodeNotification'));
	processInclude(require('friartux/components/grpAuditNotification'));
	processInclude(require('friartux/appointmentModal'));
	processInclude(require('friartux/components/customerPurposeModal'));
	processInclude(require('friartux/components/eventDateModal'));
	processInclude(require('friartux/components/tooltip'));
	processInclude(require('friartux/components/accessibility'));
	processInclude(require('friartux/fitFinder/overwriteFit'));
	processInclude(require('friartux/components/autocomplete'));
	processInclude(require('friartux/components/abDatepicker'));
	processInclude(require('friartux/events/freeTryOn'));
	// Poptin is Cookiebot-gated as "marketing"; clean up what it dropped if consent is withdrawn.
	require('friartux/utils/poptin').init();
});

require('base/thirdParty/bootstrap');
require('base/components/spinner');
require('bootstrap-fileinput/js/plugins/buffer');
require('bootstrap-fileinput/js/plugins/filetype');
require('bootstrap-fileinput');
require('ab-datepicker');
require('friartux/thirdParty/abDatepicker');

var navBarFixed = $(".navbar-fixed-light");
var stickyDiv = "fixed-top";
var headerHeight = $('.header').height();

$(window).on('scroll', function() {
	if( $(this).scrollTop() > headerHeight ) {
		navBarFixed.addClass(stickyDiv);
	} else {
		navBarFixed.removeClass(stickyDiv);
	}
});

$(function() {
	if (!window.GlobalPreferences.isPRODEnv) {
		if (!window.localStorage.getItem('boldMetricsStore')){
			window.localStorage.setItem(
				'boldMetricsStore',
				JSON.stringify({ store: 'friartux' })
			)
		}
	}
});
